BX.showWait = function (node, msg) {
    var overlay = BX.create('div', {
        props: {
            className: 'custom-loader-overlay'
        }
    });
    var loader = BX.create('div', {
        props: {
            className: 'custom-loader'
        },
        html: `<div class="custom-loader-spinner"></div><div class="custom-loader-text">${msg || 'Загрузка...'}</div>`
    });
    overlay.appendChild(loader);
    document.body.appendChild(overlay);
    if (node) {
        BX(node).loader = overlay;
    }

    return overlay;
};

BX.closeWait = function (node, loader) {
    if (node) {
        loader = loader || BX(node).loader;
    }

    if (loader) {
        BX.remove(loader);
        if (node) {
            BX(node).loader = null;
        }
    } else {
        var loaders = document.querySelectorAll('.custom-loader-overlay');
        loaders.forEach(function (loader) {
            BX.remove(loader);
        });
    }
};